import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { DatePickerComponent } from './date-picker.component';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { FiRangeCalendarComponent } from './fi-range-calendar/fi-range-calendar.component';
import { MatButtonModule } from '@angular/material/button';
import { FiCustomInputValidatorModule } from '@fi-shared/fi-directives/fi-custom-input-validator/fi-custom-input-validator.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        FiAppTextSharedModule,
        FiErrorMessageModule,
        MatButtonModule,
        FiCustomInputValidatorModule,
    ],
    declarations: [DatePickerComponent, FiRangeCalendarComponent],
    exports: [DatePickerComponent, FiRangeCalendarComponent],
})
export class FiDatePickerModule {}
